export enum Currency {
  EUR = 'EUR',
  USD = 'USD',
}

export enum FetchState {
  ERRORED = 'errored',
  FINISHED = 'finished',
  IN_PROGRESS = 'in-progress',
  INITIAL = 'initial',
  SUCCEEDED = 'succeeded',
}

export enum Locale {
  'de-DE' = 'de-DE',
  'en-GB' = 'en-GB',
  'en-US' = 'en-US',
  'fr-FR' = 'fr-FR',
}

export enum ValidationState {
  ERROR = 'error',
  INITIAL = 'initial',
  VALID = 'valid',
}

export type LocalizedValue = {
  [key in Locale]: string;
};

export interface Price {
  amount: number;
  currency_code: Currency;
}
